import { PlayHistoryScreen } from '@/screens/profile-screen/PlayHistoryScreen'

export default function () {
  return <PlayHistoryScreen />
}
